import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleNewLayoutComponent } from './role-new-layout.component';
import { RoleRightsCardsComponent } from './role-rights-cards/role-rights-cards.component';
import { RoleGeneralInfoComponent } from './role-rights-cards/role-general-info/role-general-info.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { RoleRightsCardComponent } from './role-rights-cards/role-rights-card/role-rights-card.component';
import { RoleBriefInfoComponent } from './role-rights-cards/role-brief-info/role-brief-info.component';
import { RoleExtendedRightsComponent } from './role-extended-rights/role-extended-rights.component';
import { RoleExtendedRightsDescriptionCardComponent } from './role-extended-rights/role-extended-rights-description-card/role-extended-rights-description-card.component';
import { RoleApplicationSettingComponent } from './role-rights-cards/role-rights-card/role-application-setting/role-application-setting.component';
import { RoleCustomButtonComponent } from './role-rights-cards/role-rights-card/role-custom-button/role-custom-button.component';
import { RoleApplicationSettingEditDialogComponent } from './role-rights-cards/role-rights-card/role-application-setting/role-application-setting-edit-dialog/role-application-setting-edit-dialog.component';
import { RoleCustomButtonEditDialogComponent } from './role-rights-cards/role-rights-card/role-custom-button/role-custom-button-edit-dialog/role-custom-button-edit-dialog.component';
import { RoleUsersListDialogComponent } from './role-rights-cards/role-brief-info/role-users-list-dialog/role-users-list-dialog.component';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule } from '@angular/forms';
import { FiAutofocusModule } from '@fi-shared/fi-directives/autofocus/autofocus.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiUsersListRelatedToObjectTypeModule } from '@fi-shared/fi-users-list-related-to-object-type/fi-users-list-related-to-object-type.module';
import { FiCheckboxListModule } from '@fi-shared/checkbox-list';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiObjectEditorInfoModule } from '@fi-shared/fi-object-editor-info/fi-object-editor-info.module';
import { FiCheckbox2Module } from '@fi-shared/fi-checkbox2/fi-checkbox2.module';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        FiProfileIconModule,
        MatButtonModule,
        BrowserAnimationsModule,
        FiToggleSwitchModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        FiTwoColumnsContainerModule,
        FiAppTextSharedModule,
        MatCardModule,
        MatIconModule,
        MatTabsModule,
        FormsModule,
        FiAutofocusModule,
        InfoIconModule,
        FiUsersListRelatedToObjectTypeModule,
        FiCheckboxListModule,
        FiIconTooltipButtonModule,
        FiObjectEditorInfoModule,
        FiCheckbox2Module,
        FiTooltipModule,
    ],
    exports: [RoleNewLayoutComponent],
    declarations: [
        RoleNewLayoutComponent,
        RoleRightsCardsComponent,
        RoleGeneralInfoComponent,
        RoleRightsCardsComponent,
        RoleRightsCardComponent,
        RoleBriefInfoComponent,
        RoleExtendedRightsComponent,
        RoleExtendedRightsDescriptionCardComponent,
        RoleApplicationSettingComponent,
        RoleCustomButtonComponent,
        RoleApplicationSettingEditDialogComponent,
        RoleCustomButtonEditDialogComponent,
        RoleUsersListDialogComponent,
    ],
})
export class RoleNewLayoutModule {}
